import React from 'react';
import { WalletType } from '@types';
import WalletIcon from '@components/WalletIcon';
import { shortenAddress } from '@lib/utils';
import clsx from 'clsx';

interface Props {
  walletAddress: string;
  walletType: WalletType;
  hasShadow?: boolean;
  size?: 'small' | 'medium';
  textClassName?: string;
}

const WalletAddress = ({
  walletAddress,
  walletType,
  hasShadow = true,
  size = 'small',
  textClassName,
}: Props) => {
  return (
    <>
      <div className="flex">
        <div
          className={clsx('flex rounded-small', {
            'bg-black shadow-default w-full p-2': hasShadow === true,
          })}
        >
          <WalletIcon
            variant={walletType}
            className={clsx('mr-1', {
              'text-heading4': size === 'small',
              'text-heading3': size === 'medium',
            })}
            idPrefix="wallet-address"
          />
          <div
            className={clsx(
              'font-semibold',
              {
                'text-gray': hasShadow === true,
                'text-white': hasShadow === false,
              },
              { 'text-heading5': size === 'medium' },
              textClassName
            )}
          >
            {shortenAddress(walletAddress)}
          </div>
        </div>
      </div>
    </>
  );
};

export default WalletAddress;
